import React from 'react'

import { AppearingWrapper, SectionContainer } from 'Components/Blocks'
import { Column } from 'Components/UI'

import { LANDING_CONTENT_PX, LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

import Gallery from './Gallery'
import Title from './Title'

function WelcomeSection() {
  return (
    <SectionContainer px={LANDING_CONTENT_PX}>
      <AppearingWrapper centered>
        <Column
          alignCenter
          fullWidth
          gap={11}
          maxWidth={LANDING_CONTENT_WIDTH_PX}
          pt={80}
        >
          <Title />

          <Gallery />
        </Column>
      </AppearingWrapper>
    </SectionContainer>
  )
}

export default WelcomeSection
